import apiService, { ApiService } from './ApiService';
import { apis } from '../utility/constants';
import { GenerateCodeResponse, VerificationCodeRequest, VerifyCodeResponse } from '../types/phoneVerification';

class VerificationCodeService {
  private route = apis.verificationCode;

  constructor(private api: ApiService) {}

  generateCode = (phone: string) => this.api.put<GenerateCodeResponse>(this.route.generateCode, { phone });

  verifyCode = (payload: VerificationCodeRequest) => this.api.put<VerifyCodeResponse>(this.route.verifyCode, payload);
}

export default new VerificationCodeService(apiService);
